import { useContext } from "react";
import { Contex } from "../kzContex";
import { Carousel } from 'react-bootstrap';

const BannerPromotion = () => {
    const { banner } = useContext(Contex);

    return (
        <div className="container bannerpromotion">
            <Carousel interval={5000}>
                {banner.map((b, index) => (
                    <Carousel.Item key={index}>
                        <img
                            className="d-block w-100"
                            src={b.image}
                            alt="First slide"
                        />
                    </Carousel.Item>
                ))}
            </Carousel>
        </div>
    )
}

export default BannerPromotion;